import styles from "./inflation.module.css"

import React from "react"
import * as util from "activities/util"
import * as shared from "activities/components/shared"
import * as inputs from "activities/components/inputs"

import {Tooltip} from "shared/tooltips"

export default shared.ActivityFactory(
  ({getProps, getState, updateState}) => {
    const state = getState()
    const {salary, savings, inflationRate, yearsPassed, resetKey} = state
    const {id} = getProps()

    const rate = inflationRate / 100

    const year = new Date().getFullYear()
    const dollar = 1
    const milk = 3.5
    const futureYear = year + yearsPassed
    const futureDollar = dollar * Math.pow(1 - rate, yearsPassed)
    const futureMilk = milk * Math.pow(1 + rate, yearsPassed)
    const futureSalary = salary * Math.pow(1 - rate, yearsPassed)
    const futureSavings = savings * Math.pow(1 - rate, yearsPassed)

    return (
      <div>
        <shared.Content className={styles["wrapper"]}>
          <shared.Calculator className={styles["calculator"]}>
            <inputs.CalcInput id={id} title="Your Salary" onChange={updateState("salary", util.fromString)} initialValue={salary} resetKey={resetKey} />
            <inputs.CalcInput id={id} title="Your Savings" onChange={updateState("savings", util.fromString)} initialValue={savings} resetKey={resetKey} />
            <inputs.RangeInput
              id={id}
              title="Rate of Inflation"
              onChange={updateState("inflationRate", parseFloat)}
              initialValue={inflationRate}
              min={0}
              max={8}
              step={0.1}
              units="%"
              valueType="percent"
              resetKey={resetKey}
            />
            <inputs.Input id={id} title="Years Passed" onChange={updateState("yearsPassed", util.fromString)} value={yearsPassed} valueType="number" />
          </shared.Calculator>
          <div className={styles["results"]}>
            <div></div>
            <div className={styles["column-title"]}>Today's Value</div>
            <div className={styles["column-title"]}>{futureYear} Value</div>

            <div className={styles["row-title"]}>A Dollar</div>
            <div className={styles["result"]}>{util.formatDollarsNoCents(dollar)}</div>
            <div className={styles["result"]}>{util.formatDollars(futureDollar)}</div>

            <div className={styles["row-title"]}>A Gallon of Milk</div>
            <div className={styles["result"]}>{util.formatDollars(milk)}</div>
            <div className={styles["result"]}>{util.formatDollars(futureMilk)}</div>

            <div className={styles["row-title"]}>Your Salary</div>
            <div className={styles["result"]}>{util.formatDollarsNoCents(salary)}</div>
            <div className={styles["result"]}>
              {util.formatDollarsNoCents(futureSalary)}
              <Tooltip align={"1px"}>Assuming your salary stays the same, the value of it will decrease with inflation.</Tooltip>
            </div>

            <div className={styles["row-title"]}>
              Your Savings <span>(0% Interest)</span>
            </div>
            <div className={styles["result"]}>{util.formatDollarsNoCents(savings)}</div>
            <div className={styles["result"]}>
              {util.formatDollarsNoCents(futureSavings)}
              <Tooltip align={"1px"}>Inflation doesn't mean you're losing money, but the dollars you've saved are losing value.</Tooltip>
            </div>
          </div>
        </shared.Content>
      </div>
    )
  },
  {
    stateFilter: (state) => state,
    defaultProps: {
      id: "inflation-calculator",
      className: "inflation-calculator",
      title: "Inflation Calculator",
      subtitle: "See how inflation affects the value of money. What salary will you need to maintain your standard of living? Will your savings lose worth?"
    },
    defaultState: {
      salary: 50000,
      savings: 10000,
      inflationRate: 2,
      yearsPassed: 5
    }
  }
)
